import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectStructureService } from 'src/app/_services/projectStructure/projectStructure.service';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';


@Component({
  selector: 'app-myparameter-v2',
  templateUrl: './myparameter-v2.component.html',
  styleUrls: ['./myparameter-v2.component.scss']
})
export class MyparameterV2Component implements OnInit {
  
  tenantId: string;
  currentProjectId: any;
  selectedProject: any;
  userDropdownList = []; 
  getUserName: any;
  isPMOLeadORManager: boolean = false;
  isPMOAdmin: boolean = false;
  currentUser: any;
  projectv2Form;
  rowData1: any;
  rowData2: any;
  rowData3: any;
  rowData4: any;
  rowData5: any;
  rowData6: any;
  regionDropdown: any[] = [];
  industryDropdown: any[] = [];
  businessGroupDropdown: any[] = [];
  commodityDropdown: any[] = [];
  activityDropdown: any[] = [];
  projectSoftwareDropdown: any[] = [];
    
  constructor(  
    private router: Router,
    private storageService: LocalStorageService,
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private projectResourcesService: ProjectResourcesService,
    private snackBar: MatSnackBar,
    private projectStructureService: ProjectStructureService,
    ) {
      this.projectv2Form = new FormGroup({
        projectName: new FormControl("",[Validators.required]),
        projectCode: new FormControl("",Validators.compose([Validators.required,Validators.pattern('^[0-9]*$')])),
        projectDescription: new FormControl(''),
        projectManagerId: new FormControl(''),
        projectManagerName: new FormControl("",[Validators.required]),
        projectLeadId: new FormControl(''),
        projectLeadName: new FormControl(''),
        startDate: new FormControl(null,[Validators.required]),
        endDate: new FormControl(null,[Validators.required]),
        decisionDate: new FormControl(''),
        customer: new FormControl(null,[Validators.required]),
        status: new FormControl(''),
        createdByUserId: new FormControl(''),
        createdByUserName: new FormControl(''),
        totalHours: new FormControl(''),
        remainingHours: new FormControl(''),
        percentageCompleted: new FormControl(''),
        regionId: new FormControl(''),
        regionName: new FormControl(null,[Validators.required]),
        industryId: new FormControl(''),
        industryName: new FormControl(null,[Validators.required]),
        businessGroupId: new FormControl(''),
        businessGroupName: new FormControl(null,[Validators.required]),
        commodityId: new FormControl(''),
        commodityName: new FormControl(null,[Validators.required]),
        activityId: new FormControl(''),
        activityName: new FormControl(null,[Validators.required]),
        projectSoftwareId: new FormControl(''),
        projectSoftwareName: new FormControl(null,[Validators.required]),
        parentProjectId: new FormControl(''),
  
      })
     }

     // getter for easy access to form fields
    get f() {
      return this.projectv2Form.controls;
     }


  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    if (this.currentProjectId) this.getParameterByIdV2(this.currentProjectId)
    this.getUserList();
    this.getRegion();
    this.getActivity();
  }


  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getProductStructure(regionId, industryId, businessGroupId, activityId) {
    this.industryDropdown = [];
    this.businessGroupDropdown = [];
    this.commodityDropdown = [];
    this.projectSoftwareDropdown = [];
    this.projectStructureService.getIndustryByRegion(regionId).subscribe((response: any) => {
      for (let item of response) {
        this.industryDropdown.push(`${item.id} . ${item.industryName}`);
      }
    });

    this.projectStructureService.getBusinessGroupByIndustry(industryId).subscribe((response: any) => {
      for (let item of response) {
        this.businessGroupDropdown.push(`${item.id} . ${item.businessGroupName}`);
      }
    });

    this.projectStructureService.getCommodityByBusinessGroup(businessGroupId).subscribe((response: any) => {
      for (let item of response) {
        this.commodityDropdown.push(`${item.id} . ${item.commodityName}`);
      }
    });

    this.projectStructureService.getProjectSoftwareByActivity(activityId).subscribe((response: any) => {
      for (let item of response) {
        this.projectSoftwareDropdown.push(`${item.id} . ${item.projectSoftwareName}`);
      }
    });
  }

  getRegion(){
    this.regionDropdown = [];
    this.projectStructureService.getRegion().subscribe((response: any) => {
      for (let item of response) {
        this.regionDropdown.push(`${item.id} . ${item.regionName}`);
      }
    });
  }

  getIndustryByRegion(params){
    let regionId = params.target.value?.split(' . ')[0];
    this.industryDropdown = [];
    this.projectStructureService.getIndustryByRegion(regionId).subscribe((response: any) => {
      for (let item of response) {
        this.industryDropdown.push(`${item.id} . ${item.industryName}`);
      }
    });
  }

  getBusinessGroupByIndustry(params){
    let industryId = params.target.value.split(' . ')[0];
    this.businessGroupDropdown = [];
    this.projectStructureService.getBusinessGroupByIndustry(industryId).subscribe((response: any) => {
      for (let item of response) {
        this.businessGroupDropdown.push(`${item.id} . ${item.businessGroupName}`);
      }
    });
  }

  getCommodityByBG(params){
    let businessGroupId = params.target.value.split(' . ')[0];
    console.log ('businessGroupId',businessGroupId);
    this.commodityDropdown = [];
    this.projectStructureService.getCommodityByBusinessGroup(businessGroupId).subscribe((response: any) => {
      for (let item of response) {
        this.commodityDropdown.push(`${item.id} . ${item.commodityName}`);
      }
    });
  }

  getActivity(){
    this.activityDropdown = [];
    this.projectStructureService.getActivity().subscribe((response: any) => {
      this.rowData5 = response;
      for (let item of response) {
        this.activityDropdown.push(`${item.id} . ${item.activityName}`);
      }
    });
  }

  getSoftwareByActivity(params){
    let activityId = params.target.value.split(' . ')[0];
    this.projectSoftwareDropdown = [];
    this.projectStructureService.getProjectSoftwareByActivity(activityId).subscribe((response: any) => {
      for (let item of response) {
        this.projectSoftwareDropdown.push(`${item.id} . ${item.projectSoftwareName}`);
      }
    });
  }

  getParameterByIdV2(id) {
    this.projectService.getProjectV2(id).subscribe((response: any) => {
      if (response) {
        this.getProductStructure(response.regionId, response.industryId, response.businessGroupId, response.activityId);
        this.projectv2Form.patchValue(response);
        this.projectv2Form.value.projectManagerName = response.projectManagerId + " . " + response.projectManagerName;
        this.projectv2Form.value.projectLeadName = this.projectv2Form.value.projectLeadId + " . " + this.projectv2Form.value.projectLeadName;
        this.projectv2Form.value.regionName = this.projectv2Form.value.regionId + " . " + this.projectv2Form.value.regionName;
        this.projectv2Form.value.industryName = response.industryId + " . " + response.industryName;
        this.projectv2Form.value.businessGroupName = this.projectv2Form.value.businessGroupId + " . " + this.projectv2Form.value.businessGroupName;
        this.projectv2Form.value.commodityName = this.projectv2Form.value.commodityId + " . " + this.projectv2Form.value.commodityName;
        this.projectv2Form.value.activityName = this.projectv2Form.value.activityId + " . " + this.projectv2Form.value.activityName;
        this.projectv2Form.value.projectSoftwareName = this.projectv2Form.value.projectSoftwareId + " . " + this.projectv2Form.value.projectSoftwareName;
        
        this.projectv2Form.patchValue(this.projectv2Form.value);

        if(response.projectManagerId === this.currentUser.id || response.projectLeadId === this.currentUser.id){
          this.isPMOLeadORManager = true;
        }
      }
    }, error => {
      this.openSnackBar('ERROR: cannot get project by id: ' + error);
    })
  }

  updateorcreateParametersV2() {
    // if(this.isPMOLeadORManager === true){
      let details: any;
      if(this.projectv2Form.value) {
        details={
          projectName: this.projectv2Form.get('projectName').value,
          projectCode: this.projectv2Form.get('projectCode').value,
          projectDescription: this.projectv2Form.get('projectDescription').value,
          projectManagerId: parseInt(this.projectv2Form.get('projectManagerName').value.split(' . ')[0]),
          projectManagerName: this.projectv2Form.get('projectManagerName').value.split(' . ')[1],
          projectLeadId: parseInt(this.projectv2Form.get('projectLeadName').value.split(' . ')[0]),
          projectLeadName: this.projectv2Form.get('projectLeadName').value.split(' . ')[1],
          startDate: this.projectv2Form.get('startDate').value,
          endDate: this.projectv2Form.get('endDate').value,
          decisionDate: this.projectv2Form.get('decisionDate').value,
          customer: this.projectv2Form.get('customer').value,
          status: this.projectv2Form.get('status').value,
          totalHours: this.projectv2Form.get('totalHours').value,
          regionId: parseInt(this.projectv2Form.get('regionName').value.split(' . ')[0]),
          industryId: parseInt(this.projectv2Form.get('industryName').value.split(' . ')[0]),
          businessGroupId: parseInt(this.projectv2Form.get('businessGroupName').value.split(' . ')[0]),
          commodityId: parseInt(this.projectv2Form.get('commodityName').value.split(' . ')[0]),
          activityId: parseInt(this.projectv2Form.get('activityName').value.split(' . ')[0]),
          projectSoftwareId: parseInt(this.projectv2Form.get('projectSoftwareName').value.split(' . ')[0]),
        }
      }
  
      if (this.currentProjectId) {
        this.projectService.updateProjectV2(this.currentProjectId, details).subscribe(response => {
          this.backToMyProjectV2()
        }, error => {
            this.openSnackBar('ERROR: cannot update project: ' + error);
        });
      } else {
        this.projectService.createProjectV2(details).subscribe((response: any) => {
          this.backToMyProjectV2();
        }, error => {
          this.openSnackBar('ERROR: cannot create project: ' + error);
        });
      }
    // }
    // else{
    //   this.openSnackBar('Please contact your Project manager/lead to update deatils.');
    // }
  }

  backToMyProjectV2(){
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
  }


  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }
}
